import { AfterViewInit, Directive, ElementRef, OnDestroy } from '@angular/core';

@Directive({
  selector: '[libMenuItemContainer]',
  standalone: true
})
export class MenuItemContainerDirective implements AfterViewInit, OnDestroy {
  private observer?: MutationObserver;

  constructor(private el: ElementRef) {}

  ngAfterViewInit() {
    this.updateChildrenTabIndex();
    this.setupMutationObserver();
  }

  ngOnDestroy() {
    this.observer?.disconnect();
  }

  private updateChildrenTabIndex() {
    const interactiveElements = this.el.nativeElement.querySelectorAll('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])');

    interactiveElements.forEach((element: HTMLElement) => {
      element.setAttribute('tabindex', '-1');
    });
  }

  private setupMutationObserver() {
    this.observer = new MutationObserver(() => {
      this.updateChildrenTabIndex();
    });

    this.observer.observe(this.el.nativeElement, {
      childList: true,
      subtree: true
    });
  }
}
